function fetch(offset = 9, topics = null, tags = null) {
  let folderPath = document.getElementById('storiesFolderPath').textContent;
  let url = contextPath + `/.rest/stories?limit=9&offset=${offset}&@ancestor=${folderPath}`;
  if(topics) {
    const topicList = topics.split(" ") || [];
    let topicURL = "";
    //console.log(`Topics (${topicList.length > 0}): `, topicList)
    if (topicList.length > 0) {
      topicList.forEach((topic, index) => {
        topicURL =  index == 0 ? topicURL = "&topic=" + topic : topicURL = topicURL + "%7C" + topic;
      })
    }
    //console.log('Topic URL: ', topicURL);
    url = `${url}${topicURL}`;
  }
  if(tags) {
    const tagList = tags.split(" ") || [];
    let tagURL = "";
    //console.log(`Topics (${tagList.length > 0}): `, tagList)
    if (tagList.length > 0) {
      tagList.forEach((tag, index) => {
        tagURL = tagURL + "&mgnl:tags=" + tag;
      })
    }
    //console.log('Topic URL: ', tagURL);
    url = `${url}${tagURL}`;
  }

  // OrderBy publishedOn and filter not published articles
  // &orderBy=publishedOn%20desc&publishedOn%5Blte%5D=2021-07-27T14:11:38.032Z - yyyy-MM-dd’T’HH:mm:ss.SSSXXX
  let dateStr = new Date().toISOString();
  let publishedOnURL = "&orderBy=publishedOn%20desc";
  publishedOnURL = publishedOnURL + "&publishedOn%5Blte%5D=" + dateStr;
  // console.log("publishedOnURL:" + publishedOnURL);
  url = `${url}${publishedOnURL}`;

  // Not equal to defaultStoryId
  let elements = document.getElementsByClassName('contentHubHighlightTeaser');
  let defaultStoryId = elements[0].id;
  if(defaultStoryId){
    let defaultStoryURL = "&jcr:uuid%5Bne%5D=" + defaultStoryId;
    // console.log("defaultStoryURL: " + defaultStoryURL);
    url = `${url}${defaultStoryURL}`;
  }
  return $.ajax({
    type: "GET",
    url,
    dataType: 'json'
  });
}

$('#contentHubLoadMore').on('click', async function (e) {
  let offset = parseInt(e.target.dataset.offset);
  const urlParams = new URLSearchParams(window.location.search);
  //console.log('URL: ', urlParams.get('topics'));
  //console.log('Offset: ', offset);
  try {
    const {results} = await fetch(offset, urlParams.get('topics'), urlParams.get('tag'));
    let children = "";
    results.forEach(story => {
      const url = `${window.location.pathname}/${story['@name']}`;
      const truncate = (str, max, suffix) => str.length < max ? str : `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`;
      const lead = story.lead.length > 95 ? truncate(story.lead, 120, '...') : story.lead;
      const hasFocus = story?.image?.focal?.point;
      let image = '';
      if(story?.image?.focal?.point) {
        const responsive = $(window)[0].ImageVersions;
        image = `
          <picture>
            <!-- mobile -->
            <source media="(max-width: ${responsive.mobile.max_width}px)" srcset="${story.image.focal.point.urls.Cinema.replace('_WIDTH_', responsive.mobile.width).replace('_HEIGHT_', responsive.mobile.height)}">
            <!-- tablet -->
            <source media="(max-width: ${responsive.tablet.max_width}px)" srcset="${story.image.focal.point.urls.Cinema.replace('_WIDTH_', responsive.tablet.width).replace('_HEIGHT_', responsive.tablet.height)}">
            <!-- desktop -->
            <source media="(min-width: ${responsive.desktop.min_width}px)" srcset="${story.image.focal.point.urls.Cinema.replace('_WIDTH_', responsive.desktop.width).replace('_HEIGHT_', responsive.desktop.height)}">

            <img src="${story.image.focal.point.urls.Cinema.replace('_WIDTH_', responsive.desktop.width).replace('_HEIGHT_', responsive.desktop.height)}" title="${story?.title}">
          </picture>
        `;
        // image = story.image.focal.point.urls.Cinema.replace('_WIDTH_', '800').replace('_HEIGHT_', '300');
      } else {
        image = story.image['@link'];
        image = `<img src="${image}" alt="${story?.image['@name']}" />`
      }
      children += `
        <a href="${url}" class="contentHubArticleTeaser">
                <div class="image">
                    ${image}
                </div>
                <div class="content">
                    <div class="topic">
                        <div>${story?.topic?.displayName}</div>
                    </div>
                    <div class="title">${story.title}</div>
                    <p>${lead}</p>
                </div>
            </a>
      `
    });
    console.log(results);
    $('#contentHubStoryGrid').append(children);
    offset += results.length;
    e.target.dataset.offset = offset;

    const { results: lookAhead } = await fetch(offset, urlParams.get('topics'), urlParams.get('tag'));
    if(lookAhead.length === 0) {
      $(e.target).hide();
    } else {
      $(e.target).show();
    }
  } catch(error) {
    console.log(error);
  }
});
